import { FormControl } from '@angular/forms';

export const validateStrongPassword = (control: FormControl) => {
  try {
    const value = control.value;

    if (/(?=.*[a-z])/.test(value) === false) {
      return {
        lowerCase: {
          invalid: true
        }
      };
    }
    if (/(?=.*[A-Z])/.test(value) === false) {
      return {
        upperCase: {
          invalid: true
        }
      };
    }
    if (/(?=.*[0-9])/.test(value) === false) {
      return {
        number: {
          invalid: true
        }
      };
    }
    if (
      /(?=.[@%/'"!#,~&;`_<>\:\.\^\$\*\+\-\?\(\)\[\]\{\}\\\|])/.test(value) ===
      false
    ) {
      return {
        specialCharacter: {
          invalid: true
        }
      };
    }
    const stringValue: string = value;
    if (value.length < 8) {
      return {
        minLength: {
          invalid: true
        }
      };
    }
    if (value.length > 20) {
      return {
        maxLength: {
          invalid: true
        }
      };
    }
    return {};
  } catch (error) {
    return {
      invalidPassword: {
        invalid: true
      }
    };
  }
};
